export default {
	MANUAL_IMAGE: 0,
	PACKET_IMAGE: 1,
	BLOCK_GROUP: 2,
	SMALL_LOG: 3,
	SMALL_PACKET: 4,
	SMALL_MANUAL: 5,
	PACKET_IMAGE_EXTERNAL: 6,
	MANUAL_IMAGE_TEASER: 7
}